import { IconDice6 } from '@sloyd/icons';
import { Button, QuickPalettes, Tooltip } from '@sloyd/ui';
import { useKey } from 'react-use';
import { $a, isMac } from 'shared-base';
import WacomContainer from '../../containers/Wacom.container';
import { Wrapper } from './EditorActions.style';

export type EditorActionsProps = {
  ctaAction: string;
  palettes: IMaterial[];
  callbacks: {
    onAction: OnAction;
  };
};

export function EditorActions(props: EditorActionsProps) {
  const { palettes, ctaAction, callbacks } = props;

  function renderInner() {
    switch (ctaAction) {
      case 'randomize':
        return (
          <>
            <Randomize verb='randomizeObject' callbacks={callbacks} />
            <WacomContainer />
          </>
        );
      case 'quickPalettes':
        return (
          <>
            <Randomize verb='randomizeMaterial' callbacks={callbacks} />
            <QuickPalettes
              palettes={palettes}
              onSelectPalette={(paletteId: string) =>
                callbacks.onAction($a('MATERIALS', 'selectPalette', '', { paletteId }))
              }
            />
          </>
        );
    }
  }

  return (
    <Wrapper className='EditorActions-wrapper' data-testid='EditorActions-wrapper'>
      {renderInner()}
    </Wrapper>
  );
}

function Randomize(props: any) {
  const { callbacks, verb } = props;

  function onClick(ev: any) {
    callbacks.onAction($a('MODELS', ev.shiftKey ? 'randomizeBoth' : verb));
  }

  useKey(
    (event) => {
      return event.code === 'KeyR' && event.altKey;
    },
    onClick,
    { event: 'keydown' }
  );

  const instructions = isMac() ? ' ⌥⇧r' : 'alt+shift+r';

  return (
    <Tooltip
      label={`Click while holding shift to randomize everything (${instructions})`}
      position='left'
      withArrow
      openDelay={3000}
    >
      <Button
        variant='gradient'
        gradient={{ deg: 45, from: 'pink', to: 'yellow' }}
        leftSection={<IconDice6 />}
        data-track
        className='Randomize-btn'
        onClick={onClick}
      >
        Randomize
      </Button>
    </Tooltip>
  );
}

export default EditorActions;
